import iro from "@jaames/iro";
import { cloneDeep } from "lodash";

export default class TetrahedralInterpolation {
    constructor() {
        this.minValue = -3;
        this.maxValue = 3;
        this.blockName = "TetrahedralInterpolation";
        this.opacity = {
            minValue: 0,
            maxValue: 100,
        };

        this.presets = [
            {
                id: '1',
                name: "F-Stock 1",
                label: 'F-Stock 1',
                values: {
                    "r_R": "-0.43",
                    "r_G": "-0.317",
                    "r_B": "-0.231",
                    "g_R": "-0.948",
                    "g_G": "-1.217",
                    "g_B": "-0.685",
                    "b_R": "-0.421",
                    "b_G": "-0.753",
                    "b_B": "-0.551",
                    "c_R": "-0.247",
                    "c_G": "-0.616",
                    "c_B": "-0.203",
                    "m_R": "-0.187",
                    "m_G": "-0.091",
                    "m_B": "-0.456",
                    "y_R": "0.126",
                    "y_G": "-0.117",
                    "y_B": "-0.102",
                    "w_R": "0.000",
                    "w_G": "0.000",
                    "w_B": "0.000"
                }
            },
            {
                id: '2',
                label: 'F-Stock 2',
                name: "F-Stock 2",
                values: {
                    "r_R": "-0.288",
                    "r_G": "-0.093",
                    "r_B": "0.076",
                    "g_R": "0.085",
                    "g_G": "-0.378",
                    "g_B": "0.448",
                    "b_R": "0.19",
                    "b_G": "0.5",
                    "b_B": "-0.147",
                    "c_R": "-0.046",
                    "c_G": "-0.389",
                    "c_B": "-0.088",
                    "m_R": "-0.373",
                    "m_G": "-0.294",
                    "m_B": "-0.469",
                    "y_R": "-0.11",
                    "y_G": "-0.237",
                    "y_B": "0.043",
                    "w_R": "0.000",
                    "w_G": "0.000",
                    "w_B": "0.000"
                }
            },
            {
                id: '5',
                label: 'F-Stock 3',
                name: "F-Stock 3",
                values: {
                    "r_R": "-0.43",
                    "r_G": "-0.317",
                    "r_B": "-0.231",
                    "g_R": "-0.948",
                    "g_G": "-1.217",
                    "g_B": "-0.685",
                    "b_R": "-0.78",
                    "b_G": "-0.398",
                    "b_B": "-0.386",
                    "c_R": "-0.247",
                    "c_G": "-0.616",
                    "c_B": "-0.203",
                    "m_R": "-0.187",
                    "m_G": "-0.091",
                    "m_B": "-0.456",
                    "y_R": "0.126",
                    "y_G": "-0.117",
                    "y_B": "-0.102",
                    "w_R": "0.000",
                    "w_G": "0.000",
                    "w_B": "0.000"
                }
            },
            {
                id: '3',
                label: 'K-Stock 1',
                name: "K-Stock 1",
                values: {
                    "r_R": "-0.477",
                    "r_G": "-0.361",
                    "r_B": "-0.275",
                    "g_R": "-1.192",
                    "g_G": "-1.43",
                    "g_B": "-0.774",
                    "b_R": "-0.44",
                    "b_G": "-0.769",
                    "b_B": "-0.608",
                    "c_R": "-0.362",
                    "c_G": "-0.785",
                    "c_B": "-0.38",
                    "m_R": "-0.158",
                    "m_G": "-0.084",
                    "m_B": "-0.438",
                    "y_R": "0.421",
                    "y_G": "0.132",
                    "y_B": "0.004",
                    "w_R": "0.000",
                    "w_G": "0.000",
                    "w_B": "0.000"
                }
            },
            {
                id: '4',
                label: 'K-Stock 2',
                name: "K-Stock 2",
                values: {
                    "r_R": "-0.332",
                    "r_G": "-0.172",
                    "r_B": "-0.741",
                    "g_R": "-0.177",
                    "g_G": "-0.441",
                    "g_B": "0.402",
                    "b_R": "0",
                    "b_G": "0.568",
                    "b_B": "-0.194",
                    "c_R": "-0.063",
                    "c_G": "-0.369",
                    "c_B": "-0.079",
                    "m_R": "-0.139",
                    "m_G": "0.335",
                    "m_B": "-0.189",
                    "y_R": "0.067",
                    "y_G": "-0.139",
                    "y_B": "-0.003",
                    "w_R": "0.005",
                    "w_G": "-0.003",
                    "w_B": "0.008"
                }
            },
            {
                id: '6',
                label: 'K-Stock 3',
                name: "K-Stock 3",
                values: {
                    "r_R": "-0.477",
                    "r_G": "-0.361",
                    "r_B": "-0.275",
                    "g_R": "-1.192",
                    "g_G": "-1.43",
                    "g_B": "-0.774",
                    "b_R": "-0.785",
                    "b_G": "-0.44",
                    "b_B": "-0.457",
                    "c_R": "-0.362",
                    "c_G": "-0.785",
                    "c_B": "-0.38",
                    "m_R": "-0.158",
                    "m_G": "-0.084",
                    "m_B": "-0.438",
                    "y_R": "0.421",
                    "y_G": "0.132",
                    "y_B": "0.004",
                    "w_R": "0.000",
                    "w_G": "0.000",
                    "w_B": "0.000"
                }
            },
        ]
    }

    addBlock(blockNum = lutify.blocks.length) {
        UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
        let blockCanvasName = UI.createBlockCanvas(this.blockName, blockNum);
        let element = UI.getAdjustmentBlock(blockNum);

        UI.removeBlockBlendingModes($(element));

        $(element).find(".expand_options").trigger("click", [false]);

        $(element).find(".control-color-selector > span").on("click", (e, animate) => this.controlColorSelection(e.currentTarget, animate));
        $(element).find(`.control-color-selector > span[data-color="reds"]`).trigger("click", [false]);

        $(element).find('input[type="range"][data-control]').on("input", e => this.sliderHandler(e, $(element)));
        $(element).find('input[type="number"][data-control]').on("change", e => this.inputHandler(e, $(element)));

        $(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
        $(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

        $(element).find(".lut-selector__label-container").on("click", e => {
            e.stopPropagation();
            if ($(e.currentTarget).hasClass('disabled')) return;
            this.togglePresetSelector($(e.currentTarget));
        });

        $(element).find(".btn-reset-block").on("click", e => {
            e.stopPropagation();
            this.resetBlock($(element));
        });

        $(element).on("mouseout", ".lut-selector__items-container", e => {
            if (lutify.tempStoredTetrahedralInterpolationShaderPass) {
                gpu.composer.passes.forEach((pass, key) => {
                    if (pass.uid === lutify.tempStoredTetrahedralInterpolationShaderPass.uid) {
                        gpu.composer.passes[key] = lutify.tempStoredTetrahedralInterpolationShaderPass
                    }
                })

                gpu.render();
            }

            lutify.tempStoredTetrahedralInterpolationShaderPass = null;
        });

        UI.initKnob(element, {
            size: 30,
        });

        this.setPresetList(this.presets, $(element));

        blocks.add({
            name: this.blockName,
            version: '2',
            passes: [this.addPass()],
            blockNum,
            blendingMode: 0,
            blendingModeName: "Normal",
            opacity: 100,
            values: {
                r_R: 0,
                r_G: 0,
                r_B: 0,
                g_R: 0,
                g_G: 0,
                g_B: 0,
                b_R: 0,
                b_G: 0,
                b_B: 0,
                c_R: 0,
                c_G: 0,
                c_B: 0,
                m_R: 0,
                m_G: 0,
                m_B: 0,
                y_R: 0,
                y_G: 0,
                y_B: 0,
                w_R: 0,
                w_G: 0,
                w_B: 0,
            },
        });

        this.colorWheelsInit(element)
    }

    addPass() {
        let pass = gpu.createTetrahedralInterpolationShaderPass();
        gpu.addPassToComposer(pass, "toMiddle");
        return pass;
    }

    colorWheelsInit(element) {
        const container = element.querySelector(".colorwheel-container");
        new iro.ColorPicker(container, config.colorWheelOptions)
    }

    controlColorSelection(selectedColorControl, animate = true) {
        let $controlsContainer = $(selectedColorControl).closest(".block_options");
        $controlsContainer.find(".control-color-selector > span").removeClass("selected");
        $(selectedColorControl).addClass("selected");
        if (animate) {
            $controlsContainer.find(".block-sub-controls-container").fadeOut(2);
            $controlsContainer.find(`.block-sub-controls-container[data-color="${selectedColorControl.dataset.color}"]`).fadeIn();
        } else {
            $controlsContainer.find(`.block-sub-controls-container[data-color="${selectedColorControl.dataset.color}"]`).show();
        }
    }

    sliderHandler(e, $el) {
        blocks.checkSwitchHandler($el);
        lutify.getActiveBlock().passes[0].enabled = true;
        lutify.getActiveBlock().presetId = null;

        const value = e.currentTarget.value;
        const control = e.currentTarget.dataset.control

        $el.find(`input[type="number"][data-control=${control}]`).val(value)

        let block = lutify.getActiveBlock();
        block.values[control] = value;
        block.passes[0].uniforms[control].value = value;
        gpu.render();

        let $presetSelector = $(UI.getActiveBlock()).find(".lut-selector");
        $presetSelector.find(".selected-lut-name").html('Preset: Custom');
    }

    inputHandler(e, $el) {
        blocks.checkSwitchHandler($el);
        lutify.getActiveBlock().passes[0].enabled = true;
        lutify.getActiveBlock().presetId = null;

        let value = e.currentTarget.value;
        const control = e.currentTarget.dataset.control

        if (value > this.maxValue) {
            value = this.maxValue;
            $el.find(`input[type="number"][data-control=${control}]`).val(value)
        }

        if (value < this.minValue) {
            value = this.minValue;
            $el.find(`input[type="number"][data-control=${control}]`).val(value)
        }

        $el.find(`input[type="range"][data-control=${control}]`).val(value)

        let block = lutify.getActiveBlock();
        block.values[control] = value;
        block.passes[0].uniforms[control].value = value;
        gpu.render();

        let $presetSelector = $(UI.getActiveBlock()).find(".lut-selector");
        $presetSelector.find(".selected-lut-name").html('Preset: Custom');
    }

    opacitySliderHandler($element) {
        let opacityValue = $element.find(".opacity_slider").val();
        let calcOpacityValue = opacityValue * 0.01;

        $element.find(".opacity-input").val(opacityValue);

        lutify.getActiveBlock().opacity = opacityValue;
        lutify.getActiveBlock().passes[0].uniforms.opacity.value = calcOpacityValue;

        gpu.render();
    }

    opacityInputHandler($element) {
        let opacityValue = $element.find(".opacity-input").val();
        let opacitySlider = $element.find(".opacity_slider");

        if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
        if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

        opacitySlider.val(opacityValue);
        opacitySlider.trigger("input");
    }

    togglePresetSelector($el) {
        let itemsContainer = $el.siblings(".lut-selector__items-container");
        if (itemsContainer.is(":visible")) itemsContainer.hide();
        else itemsContainer.show();
    }

    onPresetSelection(el, preset) {
        blocks.checkSwitchHandler($(UI.getActiveBlock()));

        lutify.getActiveBlock().presetId = preset.id;
        this.updatePresetList(preset);

        Object.keys({...preset.values}).forEach(control => {
            UI.getActiveBlock().find(`input[type="number"][data-control=${control}]`).val(preset.values[control])
            UI.getActiveBlock().find(`input[type="range"][data-control=${control}]`).val(preset.values[control])

            let block = lutify.getActiveBlock();
            block.values[control] = preset.values[control];
            block.passes[0].uniforms[control].value = preset.values[control];
            gpu.render();
        })
    }

    updatePresetList(preset = false) {
        let $presetSelector = $(UI.getActiveBlock()).find(".lut-selector");
        $presetSelector.find(".lut-selector__items-container").hide();
        $presetSelector.find(`.lut-selector__items-container .--selected`).removeClass("--selected");

        if (lutify.getActiveBlock().presetId !== null && preset) {
            $presetSelector.find(".selected-lut-name").html('Preset: ' + preset.label);
            $presetSelector.find(`.lut-selector__items-container span[data-preset-id="${preset.id}"]`).addClass("--selected");
        } else {
            $presetSelector.find(".selected-lut-name").html('Select Preset...');
        }
    }

    setPresetList(presets, $block) {
        presets.forEach(preset => {
            let el = document.createElement('span');
            el.innerHTML = preset.label;
            el.setAttribute('data-preset-id', preset.id);
            el.addEventListener('click', e => {
                this.onPresetSelection(e.currentTarget, preset);
            });

            el.addEventListener("mouseover", e => {
                let tempPass = gpu.createTetrahedralInterpolationShaderPass();
                tempPass.uid = lutify.getActiveBlock().passes[0].uid;

                const preset = this.presets.find(preset => preset.id == e.currentTarget.dataset.presetId)

                Object.keys({...preset.values}).forEach(control => {
                    tempPass.uniforms[control].value = preset.values[control];
                })

                lutify.tempStoredTetrahedralInterpolationShaderPass = lutify.getActiveBlock().passes[0];
                gpu.composer.passes.forEach((pass, key) => {
                    if (pass.uid == tempPass.uid) gpu.composer.passes[key] = tempPass
                })

                gpu.render();
            });

            $block.find('.lut-selector__items-container').append(el)
        });
    }

    resetBlock($element) {
        $(UI.getActiveBlock()).find(".opacity-input").val(100);
        $(UI.getActiveBlock()).find(".opacity-input").trigger("change");

        lutify.getActiveBlock().presetId = null;
        this.updatePresetList();

        Object.keys(lutify.getActiveBlock().values).forEach(control => {
            const $el = $(UI.getActiveBlock()).find(`input[type="number"][data-control=${control}]`)

            if ($el) {
                $el.val(0)
                $el.trigger("change")
            }
        })

        let $presetSelector = $(UI.getActiveBlock()).find(".lut-selector");
        $presetSelector.find(".selected-lut-name").html('Select Preset...');
    }

    applyChanges($block, values, blockData) {
        Object.keys(values).forEach(control => {
            const $el = $block.find(`input[type="number"][data-control=${control}]`)

            if ($el) {
                $el.val(values[control])
                $el.trigger("change")
            }
        })

        if (blockData.presetId) {
            lutify.getActiveBlock().presetId = blockData.presetId
            const preset = this.presets.find(preset => preset.id == blockData.presetId)
            if (preset) this.updatePresetList(preset)
        }

        if ('opacity' in blockData) {
            $block.find(".opacity-input").val(parseInt(blockData.opacity));
            $block.find(".opacity-input").trigger("change");
        }
    }
}
